function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ct-viewer-white_svg__Path_9659",
  width: 35.277,
  height: 26.5,
  x: 0,
  y: 11.622,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.255
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ct-viewer-white_svg__Path_9658",
  width: 35.277,
  height: 26.5,
  x: 0,
  y: 8.888,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-2",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.255
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-2",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ct-viewer-white_svg__Path_9657",
  width: 35.277,
  height: 26.5,
  x: 0,
  y: 6.152,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-3",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.255
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-3",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ct-viewer-white_svg__Path_9656",
  width: 35.277,
  height: 26.5,
  x: 0,
  y: 3.418,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-4",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.255
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-4",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ct-viewer-white_svg__Path_9653",
  width: 35.277,
  height: 26.5,
  x: 0,
  y: 0,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-5",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.255
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-5",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ct-viewer-white_svg__cls-1{fill:#fff}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ct-viewer-white_svg__CTVIewerToolbar"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#ct-viewer-white_svg__Path_9659)"
}, /*#__PURE__*/React.createElement("path", {
  id: "ct-viewer-white_svg__Path_9659-2",
  d: "M.146 4.082L8.718 0l8.706 4.082L8.718 8.5z",
  className: "ct-viewer-white_svg__cls-1",
  transform: "translate(8.85 17.62)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#ct-viewer-white_svg__Path_9658)"
}, /*#__PURE__*/React.createElement("path", {
  id: "ct-viewer-white_svg__Path_9658-2",
  d: "M.146 4.082L8.718 0l8.706 4.082L8.718 8.5z",
  className: "ct-viewer-white_svg__cls-1",
  transform: "translate(8.85 14.89)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#ct-viewer-white_svg__Path_9657)"
}, /*#__PURE__*/React.createElement("path", {
  id: "ct-viewer-white_svg__Path_9657-2",
  d: "M.146 4.082L8.718 0l8.706 4.082L8.718 8.5z",
  className: "ct-viewer-white_svg__cls-1",
  transform: "translate(8.85 12.15)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#ct-viewer-white_svg__Path_9656)"
}, /*#__PURE__*/React.createElement("path", {
  id: "ct-viewer-white_svg__Path_9656-2",
  d: "M.146 4.082L8.718 0l8.706 4.082L8.718 8.5z",
  className: "ct-viewer-white_svg__cls-1",
  transform: "translate(8.85 9.42)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#ct-viewer-white_svg__Path_9653)"
}, /*#__PURE__*/React.createElement("path", {
  id: "ct-viewer-white_svg__Path_9653-2",
  d: "M.146 4.082L8.718 0l8.706 4.082L8.718 8.5z",
  className: "ct-viewer-white_svg__cls-1",
  transform: "translate(8.85 6)"
})));
function SvgCtViewerWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.277,
    height: 38.122,
    viewBox: "0 0 35.277 38.122"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='35.277' height='38.122' viewBox='0 0 35.277 38.122'%3e %3cdefs%3e %3cfilter id='Path_9659' width='35.277' height='26.5' x='0' y='11.622' filterUnits='userSpaceOnUse'%3e %3cfeOffset dy='3'/%3e %3cfeGaussianBlur result='blur' stdDeviation='3'/%3e %3cfeFlood flood-opacity='.255'/%3e %3cfeComposite in2='blur' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cfilter id='Path_9658' width='35.277' height='26.5' x='0' y='8.888' filterUnits='userSpaceOnUse'%3e %3cfeOffset dy='3'/%3e %3cfeGaussianBlur result='blur-2' stdDeviation='3'/%3e %3cfeFlood flood-opacity='.255'/%3e %3cfeComposite in2='blur-2' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cfilter id='Path_9657' width='35.277' height='26.5' x='0' y='6.152' filterUnits='userSpaceOnUse'%3e %3cfeOffset dy='3'/%3e %3cfeGaussianBlur result='blur-3' stdDeviation='3'/%3e %3cfeFlood flood-opacity='.255'/%3e %3cfeComposite in2='blur-3' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cfilter id='Path_9656' width='35.277' height='26.5' x='0' y='3.418' filterUnits='userSpaceOnUse'%3e %3cfeOffset dy='3'/%3e %3cfeGaussianBlur result='blur-4' stdDeviation='3'/%3e %3cfeFlood flood-opacity='.255'/%3e %3cfeComposite in2='blur-4' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cfilter id='Path_9653' width='35.277' height='26.5' x='0' y='0' filterUnits='userSpaceOnUse'%3e %3cfeOffset dy='3'/%3e %3cfeGaussianBlur result='blur-5' stdDeviation='3'/%3e %3cfeFlood flood-opacity='.255'/%3e %3cfeComposite in2='blur-5' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cstyle%3e .cls-1%7bfill:%23fff%7d %3c/style%3e %3c/defs%3e %3cg id='CTVIewerToolbar'%3e %3cg filter='url(%23Path_9659)' transform='translate(9 6) translate(-9 -6)'%3e %3cpath id='Path_9659-2' d='M.146 4.082L8.718 0l8.706 4.082L8.718 8.5z' class='cls-1' transform='translate(8.85 17.62)'/%3e %3c/g%3e %3cg filter='url(%23Path_9658)' transform='translate(9 6) translate(-9 -6)'%3e %3cpath id='Path_9658-2' d='M.146 4.082L8.718 0l8.706 4.082L8.718 8.5z' class='cls-1' transform='translate(8.85 14.89)'/%3e %3c/g%3e %3cg filter='url(%23Path_9657)' transform='translate(9 6) translate(-9 -6)'%3e %3cpath id='Path_9657-2' d='M.146 4.082L8.718 0l8.706 4.082L8.718 8.5z' class='cls-1' transform='translate(8.85 12.15)'/%3e %3c/g%3e %3cg filter='url(%23Path_9656)' transform='translate(9 6) translate(-9 -6)'%3e %3cpath id='Path_9656-2' d='M.146 4.082L8.718 0l8.706 4.082L8.718 8.5z' class='cls-1' transform='translate(8.85 9.42)'/%3e %3c/g%3e %3cg filter='url(%23Path_9653)' transform='translate(9 6) translate(-9 -6)'%3e %3cpath id='Path_9653-2' d='M.146 4.082L8.718 0l8.706 4.082L8.718 8.5z' class='cls-1' transform='translate(8.85 6)'/%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgCtViewerWhite as ReactComponent };